import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { formatISO } from 'date-fns';

import { DatepickerBase } from './datepicker';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
})
export class DatepickerComponent extends DatepickerBase {
  @Input() formControlRef: FormControl<string | null>;

  get isRequired(): boolean {
    return this.formControlRef.hasValidator(Validators.required);
  }

  clear(): void {
    this.formControlRef.reset();
    this.datepicker.close();
  }

  setToday(): void {
    this.formControlRef.markAsTouched();
    this.formControlRef.setValue(formatISO(new Date(), { representation: 'date' }));
    this.formControlRef.markAsDirty();
  }
}
